var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnconfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2V2C11.814 2 14.5 4.686 14.5 8V8C14.5 11.314 11.814 14 8.5 14V14C5.186 14 2.5 11.314 2.5 8V8C2.5 4.686 5.186 2 8.5 2Z",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 8.33333V5",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49966 10.6667C8.40766 10.6667 8.33299 10.7413 8.33366 10.8333C8.33366 10.9253 8.40833 11 8.50033 11C8.59233 11 8.66699 10.9253 8.66699 10.8333C8.66699 10.7413 8.59233 10.6667 8.49966 10.6667",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnconfirmed);
export default __webpack_public_path__ + "static/media/Unconfirmed.4d200265f2c3634915901695b8dd0a52.svg";
export { ForwardRef as ReactComponent };